import { useState } from "react";
import { Layers, UserPlus, CalendarClock } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import HigherDropFormDialog from "@/components/admin/HigherDropFormDialog";
import HigherJoinerFormDialog from "@/components/admin/HigherJoinerFormDialog";
import HigherPayByDialog from "@/components/admin/HigherPayByDialog";

const Choice = ({ testId, icon: Icon, title, hint, onClick }) => (
  <button type="button" data-testid={testId} onClick={onClick}
    className="group flex w-full items-center gap-4 rounded-2xl border border-white/10 bg-zinc-900/70 p-4 text-left transition-[transform,border-color] duration-200 hover:-translate-y-0.5 hover:border-sky-400/50">
    <span className="h-10 w-10 shrink-0 rounded-xl grid place-items-center bg-sky-500/15 text-sky-300"><Icon className="h-5 w-5" /></span>
    <span>
      <span className="block font-display font-bold">{title}</span>
      <span className="block text-xs text-zinc-500">{hint}</span>
    </span>
  </button>
);

export default function HigherChooserDialog({ onClose, pending = 0, onReview }) {
  const [mode, setMode] = useState(null);
  if (mode === "payby") return <HigherPayByDialog onClose={onClose} />;
  if (mode === "drop") return <HigherDropFormDialog d={{}} onClose={onClose} onSaved={() => {}} />;
  if (mode === "joiner") return <HigherJoinerFormDialog onClose={onClose} onSaved={() => {}} />;
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="higher-chooser-dialog" className="bg-zinc-950 border-zinc-800 sm:rounded-2xl">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">Yani - Higher</DialogTitle>
          <DialogDescription>What would you like to add?</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <Choice testId="higher-choose-drop" icon={Layers} title="Add Higher Drop" hint="Round name, sets, missing items and EMS" onClick={() => setMode("drop")} />
          <Choice testId="higher-choose-joiner" icon={UserPlus} title="Add Higher Joiner" hint="Add a name to the Higher Joiner list" onClick={() => setMode("joiner")} />
          <Choice testId="higher-choose-payby" icon={CalendarClock} title="EMS Pay-by Date" hint="One pay-by date for all Higher EMS" onClick={() => setMode("payby")} />
          {pending > 0 && (
            <button type="button" data-testid="higher-review-payments-link" onClick={onReview} className="w-full rounded-xl border border-amber-500/40 bg-amber-500/10 px-4 py-2.5 text-sm font-semibold text-amber-200 transition-colors hover:bg-amber-500/20">
              Review {pending} EMS payment{pending === 1 ? "" : "s"} waiting
            </button>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
